import { apiV1Client } from "lib/apiClient";
import { ApiResponse } from "types/api";
import { MapDisplaySetting } from "types/map";
import { WORKER_OPERATIONS } from "types/operations";
import { CleaningMapListResponse } from "types/response/map";

const workerPath = "/worker";

/**
 * 担当ビルに紐づくマップ一覧を取得
 */
export const callListMap = async () => {
  const res = await apiV1Client.post<ApiResponse<CleaningMapListResponse>>(
    workerPath,
    {
      operation: WORKER_OPERATIONS.map.listInCurrentBuilding,
    }
  );
  return res.data.data;
};

type UpdataParams = {
  mapId: string;
  mapName: string;
  description?: string;
  displaySetting: MapDisplaySetting;
};

/**
 * マップ更新リクエストを送信する
 */
export const callUpdateMap = async (input: UpdataParams) => {
  await apiV1Client.post<ApiResponse<null>>(workerPath, {
    operation: WORKER_OPERATIONS.map.update,
    data: {
      ...input,
    },
  });
};

type DeleteParams = {
  mapId: string;
};
/**
 * マップ削除リクエストを送信する
 */
export const callDeleteMap = async (input: DeleteParams) => {
  await apiV1Client.post<ApiResponse<null>>(workerPath, {
    operation: WORKER_OPERATIONS.map.delete,
    data: {
      ...input,
    },
  });
};
